// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#009ccc","container":"TagAddButton-module--container--3c7wE","tag_icon":"TagAddButton-module--tag_icon--ZiCVC","add_icon":"TagAddButton-module--add_icon--2RV9O"};